import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useDatesState } from "./auth-service-tools620.js";
import { useDatesContext } from "./auth-service-tools577.js";
import "./auth-service-tools36.js";
import { shiftTimezone } from "./auth-service-tools574.js";
import "react";
import { Calendar } from "./auth-service-tools616.js";
import { factory } from "./auth-service-tools248.js";
import { useProps } from "./auth-service-tools225.js";
import { useResolvedStylesApi } from "./auth-service-tools195.js";
const defaultProps = {
  type: "default",
  defaultLevel: "month",
  numberOfColumns: 1
};
const DatePicker = factory((_props, ref) => {
  const props = useProps("DatePicker", defaultProps, _props);
  const {
    classNames,
    styles,
    vars,
    type,
    defaultValue,
    value,
    onChange,
    __staticSelector,
    getDayProps,
    allowSingleDateInRange,
    allowDeselect,
    onMouseLeave,
    numberOfColumns,
    hideOutsideDates,
    __onDayMouseEnter,
    __onDayClick,
    __timezoneApplied,
    ...others
  } = props;
  const {
    onDateChange,
    onRootMouseLeave,
    onHoveredDateChange,
    getControlProps
  } = useDatesState({
    type,
    level: "day",
    allowDeselect,
    allowSingleDateInRange,
    value,
    defaultValue,
    onChange,
    onMouseLeave,
    applyTimezone: !__timezoneApplied
  });
  const {
    resolvedClassNames,
    resolvedStyles
  } = useResolvedStylesApi({
    classNames,
    styles,
    props
  });
  const ctx = useDatesContext();
  return /* @__PURE__ */jsxRuntimeExports.jsx(Calendar, {
    ref,
    minLevel: "month",
    classNames: resolvedClassNames,
    styles: resolvedStyles,
    __staticSelector: __staticSelector || "DatePicker",
    onMouseLeave: onRootMouseLeave,
    numberOfColumns,
    hideOutsideDates: hideOutsideDates != null ? hideOutsideDates : numberOfColumns !== 1,
    __onDayMouseEnter: (_event, date) => {
      onHoveredDateChange(date);
      __onDayMouseEnter == null ? void 0 : __onDayMouseEnter(_event, date);
    },
    __onDayClick: (_event, date) => {
      onDateChange(date);
      __onDayClick == null ? void 0 : __onDayClick(_event, date);
    },
    getDayProps: date => ({ ...getControlProps(date),
      ...(getDayProps == null ? void 0 : getDayProps(date))
    }),
    ...others,
    date: shiftTimezone("add", others.date, ctx.getTimezone(), __timezoneApplied),
    __timezoneApplied: true
  });
});
DatePicker.classes = Calendar.classes;
DatePicker.displayName = "@mantine/dates/DatePicker";
export { DatePicker };